<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :table-options="tableOptions"
    :search-items="searchItems"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/pharmacy/cooperation/cooperationnutraceuticals',
      // Web路径
      webPath: 'pharmacy/pharmacy/cooperation/cooperationnutraceuticals',
      tableOptions: ['details', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "cooperationCode",
              span: 6,
              name: "签约信息编码",
              type: "text",
              config: {
                edit: false
              }
            },
            // {
            //   code: "cooperationName",
            //   name: "签约信息名称",
            //   type: "text",
            //   span: 6,
            //   config: {
            //     edit: false
            //   }
            // },
            {
              code: "nutraceuticalsCode",
              span: 6,
              name: "药品信息编码",
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "nutraceuticalsName",
              name: "药品信息名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "effectiveSign",
              name: "有效标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "无效" },
                  { key: "1", value: "有效" }
                ]
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "cooperationCode",
          span: 6,
          name: "签约信息编码",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "cooperationPharmacyCode",
          name: "药房编码",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "cooperationPharmacyName",
          name: "药房名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "cooperationStoreCode",
          name: "门店编码",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "cooperationStoreName",
          name: "门店名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "nutraceuticalsCode",
          span: 6,
          name: "药品信息编码",
          type: "text",
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "nutraceuticalsName",
          name: "药品信息名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "effectiveSign",
          name: "有效标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            defaultValue: '0',
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "无效" },
              { key: "1", value: "有效" }
            ]
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "cooperationCode",
              span: 6,
              name: "签约信息编码",
              type: "popup",
              config: {
                url: "pharmacy/pharmacy/cooperation/cooperation",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'pharmacyName', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("cooperationName", row.pharmacyName)
                  this.$refs.commonPage.updateFormData("cooperationId", row.id)
                  this.$refs.commonPage.updateFormData("pharmacyCode", row.pharmacyCode)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.pharmacyName)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.pharmacyId)
                  this.$refs.commonPage.updateFormData("storeCode", row.storeCode)
                  this.$refs.commonPage.updateFormData("storeName", row.storeName)
                  this.$refs.commonPage.updateFormData("storeId", row.storeId)
                }
              }
            },
            {
              code: "cooperationPharmacyCode",
              name: "药房编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "cooperationPharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "cooperationStoreCode",
              name: "门店编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "cooperationStoreName",
              name: "门店名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "nutraceuticalsCode",
              span: 6,
              name: "药品信息编码",
              type: "popup",
              config: {
                url: "pharmacy/pharmacy/pharmacy/nutraceuticals",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                rules: [
                  { required: true, message: '请选择药品信息', trigger: 'change' }
                ]
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("nutraceuticalsName", row.name)
                  this.$refs.commonPage.updateFormData("nutraceuticalsId", row.id)
                  this.$refs.commonPage.updateFormData("typeSign", row.typeSign)
                  this.$refs.commonPage.updateFormData("unitPrice", row.unitPrice)
                  // MaterielTypeBean
                  this.$refs.commonPage.updateFormData("materielTypeCode", row.materielTypeCode)
                  this.$refs.commonPage.updateFormData("materielTypeName", row.materielTypeName)
                  this.$refs.commonPage.updateFormData("materielTypeId", row.materielTypeId)

                  // IotCode
                  this.$refs.commonPage.updateFormData("iotCode", row.iotCode)

                  // InsuranceCode
                  this.$refs.commonPage.updateFormData("insuranceCode", row.insuranceCode)

                  // MedUomBean
                  this.$refs.commonPage.updateFormData("medUomCode", row.medUomCode)
                  this.$refs.commonPage.updateFormData("medUomName", row.medUomName)
                  this.$refs.commonPage.updateFormData("medUomId", row.medUomId)

                  // MedSpecBean
                  this.$refs.commonPage.updateFormData("medSpecCode", row.medSpecCode)
                  this.$refs.commonPage.updateFormData("medSpecName", row.medSpecName)
                  this.$refs.commonPage.updateFormData("medSpecId", row.medSpecId)

                  // MedDosageBean
                  this.$refs.commonPage.updateFormData("medDosageCode", row.medDosageCode)
                  this.$refs.commonPage.updateFormData("medDosageName", row.medDosageName)
                  this.$refs.commonPage.updateFormData("medDosageId", row.medDosageId)

                  // MeaUomBean
                  this.$refs.commonPage.updateFormData("meaUomCode", row.meaUomCode)
                  this.$refs.commonPage.updateFormData("meaUomName", row.meaUomName)
                  this.$refs.commonPage.updateFormData("meaUomId", row.meaUomId)

                  // ClassifyUomBean
                  this.$refs.commonPage.updateFormData("classifyUomCode", row.classifyUomCode)
                  this.$refs.commonPage.updateFormData("classifyUomName", row.classifyUomName)
                  this.$refs.commonPage.updateFormData("classifyUomId", row.classifyUomId)
                }
              }
            },
            {
              code: "nutraceuticalsName",
              name: "药品信息名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "effectiveSign",
              name: "有效标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '0',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "无效" },
                  { key: "1", value: "有效" }
                ]
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
